module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/weekdaypicker/asset/arrow-right-black.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/weekdaypicker/asset/arrow-right-black.png
// module id = 1280
// module chunks = 367